import { TypedFormGroup, TypedFormControl } from '@principle-theorem/ng-shared';
import {
  IAddressMetadata,
  type IContactDetails,
} from '@principle-theorem/principle-core/interfaces';
import { Validators } from '@angular/forms';
import { CustomValidators } from '@principle-theorem/ng-principle-shared';

type ILabFormData = Pick<IContactDetails, 'name' | 'email' | 'phone'> & {
  address: IAddressMetadata;
};

export class LabFormGroup extends TypedFormGroup<ILabFormData> {
  constructor() {
    super(
      {
        name: new TypedFormControl<string>('', Validators.required),
        email: new TypedFormControl<string>('', Validators.email),
        address: new TypedFormControl<IAddressMetadata>({ address: '' }),
        phone: new TypedFormControl<string>('', [CustomValidators.phoneNumber]),
      },
      CustomValidators.requireOneOf(['email', 'phone'])
    );
  }
}
